import compact from 'lodash/compact';
import get from 'lodash/get';
import VueScrollTo from 'vue-scrollto';

/**
 * Scroll to the first error on the page
 */
export function scrollToFirstError() {
    const errors = $('.alert, .booking-form-alert, .has-error');
    if (errors.length) {
        VueScrollTo.scrollTo(errors[0], 100, {
            container: 'body',
            duration: 500,
            easing: 'ease',
            offset: -($('header').first().height() + 90),
            force: true,
            cancelable: true,
            onStart: false,
            onDone: false,
            onCancel: false,
            x: false,
            y: true,
        });
    }
}

/**
 * Generic ajax handler
 *
 * @param error
 *
 * @param $vm
 */
export function ajaxHandler(error, $vm = this) {
    $vm.states.loading = false;
    if (error.status === 422 && typeof error.data.errors === 'object' && get($vm, 'states.validationErrors')) {
        $vm.states.validationErrors = error.data.errors;
    } else if (error.data) {
        $vm.states.errors.push(error.data.message);
    } else {
        $vm.states.errors.push(error.message);
    }

    $vm.states.errors = compact($vm.states.errors);

    // Scroll to the first error
    scrollToFirstError();
}

/**
 * One error function to rule them all. Break out into
 * error code specific handlers where needed
 *
 * @param response
 *
 * @returns {*}
 */
export function normaliseErrors(response) {
    if (normalise[response.status]) {
        return normalise[response.status](response);
    }
    const data = response.data || response.body;
    return data ? [data.message] : ['Something went wrong, sorry about that!'];
}

export const normalise = {
    /**
     * Handle 422 error codes
     *
     * @param data
     *
     * @returns {Array}
     */
    [422] ({ data }) {
        // Inconsistency in error response format here
        let errors = data.errors || data;

        errors = Object.keys(errors)
            .map((error) => errors[error])
            .reduce((errors, error) => errors.concat(error), []);

        if (!errors.length) {
            return [data.message];
        }

        return errors;
    },
};
